import axios from 'axios';
import * as appConfig from '../config'

class Service {

  constructor() {

    let service = axios.create();
    //let isLoading = false;

    // service.defaults.timeout = 3000
    // axios.defaults.timeoutErrorMessage='timeout'
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
  }


  handleSuccess(response) {
    return response;
  }

  sleepRequest = (milliseconds, originalRequest) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => resolve(this.service(originalRequest)), milliseconds);
    });
  };

  handleError = (error) => {
    let isTermsAndConditions = error.response.request.responseURL.includes('GetTermsAndConditions')
    if (isTermsAndConditions) {
      return
    }

    if (error.response.status === 504 || error.response.status === 408) {
      alert("Ka ndodhur nje vonese ne procesimin e thirrjes. Ju lutem provoni më vonë")
      window.location.reload()
      throw error
    }

    if (error.response.status !== 400) {
      const { config } = error;
      const originalRequest = config
      if (originalRequest.baseURL === appConfig.default.apiUrls.primaryServices) {
        originalRequest.baseURL = appConfig.default.apiUrls.secondaryServices
      }
      else if (originalRequest.baseURL === appConfig.default.apiUrls.primaryUserAuth) {
        originalRequest.baseURL = appConfig.default.apiUrls.secondaryUserAuth
      }

      return this.sleepRequest(1000, originalRequest);
    } else {
      alert("Ndodhi nje problem në lidhjen me sistemin. Ju lutem provoni më vonë")
      window.location.reload()
      throw error
    }


  }

  redirectTo = (document, path) => {
    document.location = path
  }
  /*retry = () => 
  {
      this.service.defaults.url = 'http://192.168.20.222/UserAuth/UserAuthService.svc/restful/NewFlowLogin'
      this.service.interceptors.response.use(response => {
        return this.service.request()
      })
  }*/
  get(path, callback) {
    return this.service.get(path).then(
      (response) => callback(response.status, response.data)
    );
  }
  patch(path, payload, callback) {
    return this.service.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload
    }).then((response) => callback(response.status, response.data));
  }

  post(baseUrl, endpoint, payload, callback) {
    return this.service.request({
      method: 'POST',
      url: endpoint,
      baseURL: baseUrl,
      responseType: 'json',
      timeout: 120000,
      headers: { 
        "deviceId": "WEB",
        "signature": "WEB"
      },
      // timeoutErrorMessage: 'asdfasdfasdf',
      //validateStatus: (status) => {return status < 200}, 
      data: payload
    })
      .then((response) => callback(response.status, response.data))
  }
}

export default new Service;